import React, { useEffect, useContext, useState } from 'react'
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { Formik } from 'formik';
import {
  Box,
  Container,
  Typography,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  OutlinedInput,
} from '@material-ui/core';

import Moment from 'moment'

import APIS from "../utils/APIS"

import UserContext from "../contexts/UserContext"
import LanguageContext from "../contexts/LanguageContext"


const OnBoarding = () => {
  const navigate = useNavigate();

  const { actLanguage, languageValues } = useContext(LanguageContext)

  const {
    currentUser,
    updateUserContext,
  } = useContext(UserContext)

  return (
    <>
      <Helmet>
        <title>OnBoarding | TheLab</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.grey',
          minHeight: '100%',
          py: 0,
          display:"flex",
          flexDirection:"column",
        }}
      >
        <Box
          sx={{
            flex:1,
            padding:["20px", "50px", "50px", "80px"],
            backgroundColor:"background.grey",
            display:"flex",
            alignItems:"center",
          }}
        >
          <Container maxWidth="sm">
            <Formik
              initialValues={{
                sexe: currentUser?.sexe !== null ? currentUser.sexe : '',
                age: currentUser?.naissance ?  Moment(currentUser.naissance).format('YYYY-MM-DD') : '',
                poste: currentUser?.poste ? currentUser.poste : '',
              }}
              validationSchema={Yup.object().shape({
                sexe: Yup.string().max(255).required(`${languageValues?.requiredField[actLanguage]}`),
                age: Yup.string().max(255).required(`${languageValues?.requiredField[actLanguage]}`),
                poste : Yup.string().min(3, `${languageValues?.requiredField[actLanguage]}`).max(255).required(`${languageValues?.requiredField[actLanguage]}`),
              })}
              onSubmit={(values, { setSubmitting }) => {
                const userData = {
                  sexe: values?.sexe,
                  age : values?.age,
                  poste : values.poste,
                  departement : 99999,
                }
                APIS.onBoard(userData).then(result => {
                  if (result?.user) {
                    updateUserContext(null, true)
                    setSubmitting(false);
                  } else {
                    alert("Error")
                    setSubmitting(false)
                  }
                })
              }}
            >
              {({
                errors,
                handleBlur,
                handleChange,
                handleSubmit,
                isSubmitting,
                touched,
                values
              }) => (
                <form onSubmit={handleSubmit}>
                  <Box sx={{ mb: 2, textAlign:"center" }}>
                    <Typography
                      color="text.blackTitle"
                      variant="h2"
                    >
                      {languageValues?.onBoarding?.title[actLanguage]}
                    </Typography>
                  </Box>
                  <Box sx={{display:"flex", flexDirection:["column", "row"], columnGap:"20px"}}>
                      <FormControl
                        fullWidth
                        margin="normal"
                        error={Boolean(touched.sexe && errors.sexe)}
                        variant="outlined"
                        sx={{
                          "& .MuiInputLabel-root" : {
                            color:"black !important"
                          }
                        }}
                      >
                        <InputLabel shrink>{languageValues?.onBoarding?.sexe[actLanguage]?.toUpperCase()}</InputLabel>
                        <Select
                          input={<OutlinedInput notched label={languageValues?.onBoarding?.sexe[actLanguage]?.toUpperCase()} />}
                          name="sexe"
                          value={values.sexe}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          placeholder="..."
                        >
                          <MenuItem value={0}>Une Femme</MenuItem>
                          <MenuItem value={1}>Un Homme</MenuItem>
                        </Select>
                        <FormHelperText>{touched.sexe && errors.sexe}</FormHelperText>
                      </FormControl>
                      <TextField
                        InputLabelProps={{ shrink: true }}
                        error={Boolean(touched.age && errors.age)}
                        fullWidth
                        helperText={touched.age && errors.age}
                        margin="normal"
                        name="age"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        type="date"
                        label={languageValues?.onBoarding?.age[actLanguage]?.toUpperCase()}
                        value={values.age}
                        variant="outlined"
                        sx={{
                          "& .MuiInputLabel-root" : {
                            color:"black !important"
                          }
                        }}
                      />
                  </Box>
                  <Box sx={{textTransform:"uppercase", fontSize:["12px", "15px"],paddingTop:"10px",}}>
                    {languageValues?.myAccount?.poste[actLanguage]}
                  </Box>
                  <TextField
                    error={Boolean(touched.poste && errors.poste)}
                    fullWidth
                    helperText={touched.poste && errors.poste}
                    margin="normal"
                    name="poste"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    type="text"
                    value={values.poste}
                    variant="outlined"
                    placeholder="ex. RisingUp"
                  />
                  <Box sx={{ py: 2 }}>
                    <Button
                      color="primary"
                      disabled={isSubmitting}
                      fullWidth
                      size="large"
                      type="submit"
                      variant="contained"
                    >
                      {languageValues?.continue[actLanguage]}
                    </Button>
                  </Box>
                </form>
              )}
            </Formik>
          </Container>
        </Box>
      </Box>
    </>
  )
};

export default OnBoarding;
